const azureDataQueryRoots = new Set([
  "advisor",
  "costs",
  "credits",
  "governance",
  "insights",
  "orphaned-resources",
  "reservations",
  "resource-performance",
  "service-costs",
  "tag-costs",
  "tag-keys",
  "tag-values"
]);

export function isAzureDataQueryKey(queryKey: readonly unknown[]): boolean {
  const root = queryKey[0];
  return typeof root === "string" && azureDataQueryRoots.has(root);
}
